
import React, { Suspense } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import { trackPageview } from '@cvt/tracking';
import { useRouter } from '@cvt/routing';
import { useScrollTop } from '@cvt/hooks/useScrollTop';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';
import ErrorBoundary from '@cvt/components/ErrorBoundary';

import { AuthContext } from '@modules/Auth/contexts';
import { Authenticated, NotAuthenticated } from '@modules/Auth/components';
import { Login, SignUp, ResetPassword } from '@modules/Auth/views';

import PaymentSuccessPage from '@modules/Payments/PaymentSuccess';
import { Gift } from '@pages/Gift/Gift';
import { ReGift } from '@pages/Gift/ReGift';
import { CreateTribute } from './Tributes/CreateTribute';
import { EditTribute } from './Tributes/EditTribute';
import { ViewTribute } from './Tributes/ViewTribute';
import { TributesDashboard } from './Dashboard/TributesDashboard';

import { StartHere } from './Info/StartHere';


export const Root = () => {
  const router = useRouter();
  const location = useLocation();
  const { loading } = React.useContext(AuthContext);

  useScrollTop();

  React.useEffect(() => {
    trackPageview();
  }, [location]);

  if (loading) {
    return <BodyLoading height="100vh"/>;
  }

  return (
    <ErrorBoundary>
      <Suspense fallback={<BodyLoading height="100vh"/>}>
        <NotAuthenticated>
          <Routes>
            <Route path={router.auth.login.path} element={<Login/>}/>
            <Route path={router.auth.resetPassword.path} element={<ResetPassword/>}/>
            <Route path={router.auth.signup.path} element={<SignUp/>}/>
            <Route path={router.tributes.create.details.path} element={<CreateTribute/>}/>
            <Route path={`${router.tributes.view().path}/*`} element={<ViewTribute/>}/>
            <Route path={router.gift.create.path} element={<Gift/>}/>
            <Route path={router.start.path} element={<StartHere />} />
            <Route path="*" element={<Navigate to={router.tributes.create.details.path}/>}/>
          </Routes>
        </NotAuthenticated>
        <Authenticated>
          <Routes>
            <Route path={`${router.tributes.create.path}/*`} element={<CreateTribute/>}/>
            <Route path={`${router.tributes.edit().path}/*`} element={<EditTribute/>}/>
            <Route path={router.home.path} element={<TributesDashboard/>}/>
            <Route path={`${router.tributes.view().path}/*`} element={<ViewTribute/>}/>
            <Route path={router.tributes.myTributes.path} element={<TributesDashboard/>}/>
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path={router.gift.create.path} element={<Gift/>}/>
            <Route path={router.gift.regift().path} element={<ReGift/>}/>
            <Route path={router.start.path} element={<StartHere />} />
            <Route path="*" element={<Navigate to={router.home.path}/>}/>
          </Routes>
        </Authenticated>
      </Suspense>
    </ErrorBoundary>
  );
};
